export default "__VITE_ASSET__B2r4Lxbj__"